import { styled } from 'theme'

export const StyledImportFeedback = styled.div`
  width: 500px;
  margin: 0 auto;
  padding: 80px 0px 48px;
`
